import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M8.667 6.667h3.334l-4 4-4-4h3.333V2h1.333v4.667zm-6 6h10.667V8h1.333v5.333a.667.667 0 01-.666.667H2a.666.666 0 01-.667-.667V8h1.333v4.667z"
      ></path>
    </svg>
  )
}

export default Icon
